var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WsDataTableWithTitle001',{staticClass:"mt-40",attrs:{"table-overflow":"","isloading":true,"title":'YYYY',"subtitle":'YYYY-MM',"remark":'共{number}份記錄',"column-header":_vm.header,"row-data":_vm.rowData}})
}
var staticRenderFns = []

export { render, staticRenderFns }